<div id="uploadVideosMainSection" class="main_section_headers ">
  <img class="video_icon" alt="Upload video" />
  <span i18n="@@upload-video.header.upload-video" class="ml-2">Upload Videos</span>
</div>
<ng-container *ngIf="!noVideo">
  <iposcen-spinner-overlay></iposcen-spinner-overlay>
</ng-container>
<ng-container *ngIf="noVideo">
<label>
  <input #videoInput type="file" accept="video/mp4" (change)="processFile($event,videoInput)" hidden>
</label>
<div id="uploadVideoSectionBody" class="main_section_body upload_section upload_videos_main">
  <!-- Data header with info like no. of content groups, action buttons and filters -->
  <div id="dataHeader" class="data_header">
    <span class="data_desc">
      <span i18n="@@upload-video.header.data-title" class="data_title" *ngIf='videoCount >= 2 || videoCount == 0'><strong>{{videoCount}} Videos</strong></span>&nbsp;&nbsp;
      <span class="data_title" *ngIf='videoCount == 1'><strong>{{videoCount}} {{videoLabel}}</strong></span>&nbsp;&nbsp;
      <span>
        <ng-container *ngIf='videoCount >= 2'>
          <span i18n="@@upload-image.header.sort-by">Sort by</span>:&nbsp;
          <div id="bottomButton" class="btn-group" ngbDropdown placement="bottom">
            <button type="button" ngbDropdownToggle class="btn btn-primary btn-sm dropdown-toggle"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{setLable}}
            </button>
            <div id="dropdownMenu" ngbDropdownMenu class="dropdown-menu">
              <button class="dropdown-item" *ngIf='setLable !== uploadDateLable' ngbDropdownItem
                (click)="changeSortType('date')">{{uploadDateLable}}</button>
              <button class="dropdown-item" *ngIf='setLable !== fileNameLable' ngbDropdownItem
                (click)="changeSortType('name')">{{fileNameLable}}</button>
            </div>
          </div>
        </ng-container>
      </span>
    </span>
    <span class="data_action d-flex">
      <button type="button" class="btn btn-primary btn-sm left_icon_btn" (click)='videoInput.click()'>
        <img class="upload_icon" alt="" />
        <span i18n="@@upload-video.button.upload-video">Upload Video</span>
      </button>
      &nbsp;
      <a class="info_icon" tabindex="0" data-toggle="popover" data-trigger="hover" data-placement="top" data-html="true"
        data-content="Video must be in MP4 format, allowed maximum length is 180 seconds, allowed maximum size is 30 MB">
        <img [ngbPopover]="popContent" triggers="mouseenter:mouseleave" class="info_circle_icon"
          alt="upload requirements" />
      </a>
    </span>
  </div>
  <div id="errorMessage" class="error-message">
    <div id="videoTimeError" *ngIf='videoTimeError' class="mt-2"><span i18n="@@upload-video.msg.time-error-oem">Videos must be <strong>less
          than 180 seconds long.</strong></span></div>
    <div id="fileSizeError" *ngIf='fileSizeError' class="mt-2"><span i18n="@@upload-video.msg.file-size-error-oem">Video exceeds maximum size of <strong>30 MB.</strong></span></div>
    <div id="videoTypeError" *ngIf='videoTypeError' class="mt-2"><span i18n="@@upload-video.msg.video-type-error">Incorrect file type
        received. Video must be in <strong>MP4</strong> format.</span>
    </div>
  </div>
  <ng-template #popContent>
    <div id="uploadPopOver" class="popover-upload-req">
      <div id="videoIcon" class="d-flex align-items-center">
        <img class="video_icon" alt="image" />
        <ul>
          <li><span i18n="@@upload-video.msg.video-mp4-format">Video must be in <strong>MP4</strong> format.</span></li>
          <li><span i18n="@@upload-video.msg.video-size-180SEC">Allowed maximum length is <strong>180
                seconds.</strong></span></li>
          <li><span i18n="@@upload-video.msg.video-size-30MB">Allowed maximum size is <strong>30 MB.</strong></span>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
  <!-- Videos -->
  <div id="videosCard" class="card-deck">
    <div id="tileVideoList" class="card  card-size card-margin" *ngFor="let video of tileVideo">
      <video (play)='checkVideoPlay($event)' controls>
        <source [src]="video.videoData" type="video/mp4" />
      </video>
      <div id="videoCardFooter" class="card-footer d-flex card-size">
        <span *ngIf='video.fileName.length > 15' [ngbTooltip]='video.fileName'>{{ (video.fileName | slice:0:15) + '...'
          }}</span>
        <span *ngIf='video.fileName.length <= 15'>{{ video.fileName }}</span>
        <span class="delete-img" role="button" data-toggle="modal" data-target="#deleteTileThumbnail1">
          <img class="delete_icon" [ngbTooltip]='toolTipText' alt="" (click)='open(video)' />
        </span>
      </div>
      <ng-template #VideoDeleteModal>
        <div id="videoDeletePopup" class="card deletePopup">
          <div id="videoDeleteModalHeader" class="modal-header">
            <div id="videoDeletePopupCloseIcon" (click)="dismiss()" class="close_icon">
              <img src="assets/images/popup_close_button.svg" alt="close icon" />
            </div>
          </div>
          <div id="videoDeleteModalBody" class="modal-body popup-body">
            <h2><span i18n="@@upload-image.popup.delete">Delete</span> {{deleteVideoLable}}?</h2>
            <div id="deleteEnable" *ngIf='!isDeleteDisable' class="card_desc">
              <span i18n="@@upload-image.popup.permanent-delete">This asset will be permanently deleted.</span>
            </div>
            <div id="deleteDisable" *ngIf='isDeleteDisable' class="card_desc">
              <span i18n="@@upload-image.popup.used-no-delete">This asset is used in the Content Group and you cannot delete it.</span>
            </div>
          </div>
          <div id="deleteEnableModalFooter" *ngIf='!isDeleteDisable' class="modal-footer card-footer popup-footer">
            <button type="button" (click)="dismiss()" class="btn btn-outline-primary gtmCancelDltContGrp cancel-btn">
              <span i18n="@@upload-image.button.cancel">Cancel</span>
            </button>
            <button type="button" class="btn btn-primary gtmDeleteContGrp delete-btn" (click)="deleteVideo()">
              <span i18n="@@upload-image.button.delete-media">Delete Media</span>
            </button>
          </div>
          <div id="deleteDisableModalFooter" *ngIf='isDeleteDisable' class="modal-footer card-footer popup-footer">
            <button type="button" (click)="dismiss()" class="btn btn-primary gtmCancelDltContGrp cancel-btn">
              <span i18n="@@upload-image.button.ok">OK</span>
            </button>
          </div>

        </div>
      </ng-template>
      <div id="uploadedCardBody" class="card-body card-size"><span i18n="@@upload-image.cardBody.uploaded">
          <strong>Uploaded</strong> {{video.updatedTime | dateFormat: "changeToLocalTimeZone"}}</span>
      </div>
    </div>
    <!--No Videos -->
  
      <div id="noVideos" class="no_assets" [ngClass]="{'center-align':!this.videoCount}">
        <span i18n="@@upload-video.msg.no-video" *ngIf="!this.videoCount">Please upload assets to use them while creating content group</span>
        <div id="addNewButton" class="add_new_button" [ngClass]="{'center-align':!this.videoCount}"
          role="button" (click)='videoInput.click()'>
          <img class="plus-upload-icon" alt="" />
        </div>
      </div>

  </div>
</div>

<!-- Enter Model SKU: blocks end here -->
<div id="skuModelButtonWrapper" class="button_wrapper" style="justify-content: flex-end">
  <button (click)='goBack()' type="button" class="btn btn-outline-primary btn-lg">
    <span i18n="@@upload-image.button.cancel">Cancel</span>
  </button>
  <button (click)='goNextTab()' type="button" class="btn btn-primary btn-lg">
    <span i18n="@@upload-image.button.proceed">Proceed</span>
  </button>
</div>
</ng-container>